import { useContext } from "react";

import { AuthContext } from "Contexts/Auth";

const UseAuth = () => {
  const {
    authorized,
    parsedJWT,
    isAdmin,
    refreshProfile,
    token,
    storeToken,
    logout,
    loadingAuth,
    filterRoutes,
    canAccess,
    exitMirror,
  } = useContext(AuthContext);

  return {
    authorized,
    parsedJWT,
    refreshProfile,
    storeToken,
    token,
    logout,
    loadingAuth,
    isAdmin,
    filterRoutes,
    canAccess,
    exitMirror,
  };
};

export default UseAuth;
